import React from "react";
import { ReactComponent as Logo } from "../logo.svg";

const AppLogo = ({ variant = "dark", divClassName = "", className = "" }) => {
  return (
    <div className={`w-[200px] h-auto ${divClassName}`}>
      {/* <Logo className={`w-full ${className}`} fill={fill}/> */}
      <img
        src={variant === "colored" ? "/colored-logo-cropped.png" : "/dark-logo-cropped.png"}
        className={`w-full ${className}`}
      />
    </div>
  );
};

export default AppLogo;
